import type { VideosDefinition } from 'types/videos'

export const F01_VIDEOS = {
  fitnessLevelSquats: {
    gymVisualsSquat: {
      src: '/videos/f01/light/fitness-level/squat-gym-visual.webm',
    },
  },
  fitnessLevelCrunches: {
    gymVisualsCrunches: {
      src: '/videos/f01/light/fitness-level/crunches-gym-visual.webm',
    },
  },
  fitnessLevelPlank: {
    gymVisualsPlank: {
      src: '/videos/f01/light/fitness-level/plank-gym-visual.webm',
    },
  },
} as const satisfies VideosDefinition
